import React from 'react';

type StatTileProps = {
    label: string;
    value: number;
    isLoading?: boolean;
};

const StatTile = ({ label, value, isLoading = false }: StatTileProps) => (
    <div className='bg-white shadow-portfolio-summary-card rounded-lg p-4 xl:p-5 flex flex-col gap-2' data-testid='stat-tile'>
        <span className='text-[16px] font-normal text-primary'>{label}</span>
        {isLoading ? (
            <div className='h-9 w-1/3 bg-grey-20 rounded animate-pulse' data-testid='stat-tile-skeleton' />
        ) : (
            <span className='text-[30px] leading-none font-normal text-black'>{value.toLocaleString('en-GB')}</span>
        )}
    </div>
);

export default StatTile;
